// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableViewMenuPopoverDivider-base___3S1D{padding:var(--size-1) var(--size-3_5)}.TableViewMenuPopoverDivider-fullWidth__BlVDm{padding-right:var(--size-0);padding-left:var(--size-0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TableViewMenuPopoverDivider-base___3S1D",
	"fullWidth": "TableViewMenuPopoverDivider-fullWidth__BlVDm"
};
export default ___CSS_LOADER_EXPORT___;
